/**
 * QATabs
 *
 * Tab bar for the admin-only QA page. Mirrors the header/tab treatment used by
 * AdminToolsTabs and VisitsTabs so the QA page looks like the rest of the app.
 *
 * Routes backing each tab:
 *   checks    → /qa            (smoke tests + claims data checks)
 *   locations → /qa/locations  (location coordinate QA)
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
import { withRouter } from 'utils';
import { Typography, Tabs, Tab } from '@mui/material';

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.primary.accent,
  },
  header: {
    padding: theme.spacing(3),
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  tabs: {
    paddingTop: 3,
    paddingLeft: theme.spacing(3),
  },
  indicator: {
    backgroundColor: '#FFFFFF',
    height: 2,
    marginBottom: 8,
  },
  tabPanel: {
    color: '#E0E0E0',
    '&.Mui-selected': {
      color: '#FFFFFF',
    },
    '&:hover': {
      color: '#FFFFFF',
    },
  },
});

// `value` is the tab key; `path` is where selecting it navigates. The default
// tab keeps the bare /qa URL so existing links and bookmarks still work.
const QA_TABS = [
  { value: 'checks', label: 'Data Checks', path: '/qa' },
  { value: 'locations', label: 'Location QA', path: '/qa/locations' },
];

class QATabs extends React.Component {
  render() {
    const { tab, classes } = this.props;

    return (
      <div className={classes.container}>
        <title>QA</title>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>QA</Typography>
        </div>
        <Tabs
          variant='scrollable'
          TabIndicatorProps={{ className: classes.indicator }}
          className={classes.tabs}
          value={tab}
          onChange={this.onTabChange}
        >
          {QA_TABS.map((t) => (
            <Tab
              key={t.value}
              className={classes.tabPanel}
              label={t.label}
              value={t.value}
              disableRipple
            />
          ))}
        </Tabs>
      </div>
    );
  }

  onTabChange = (event, newValue) => {
    const next = QA_TABS.find((t) => t.value === newValue);
    if (next) {
      this.props.router.navigate(next.path);
    }
  };
}

QATabs.propTypes = {
  router: PropTypes.object.isRequired,
  classes: PropTypes.object,
  tab: PropTypes.string.isRequired,
};

const styled = withStyles(styles)(QATabs);
const routed = withRouter(styled);
export { routed as QATabs, QA_TABS };
export default routed;
